export const dateCheck = {
  data() {
    return {
      // 日期只可设置当天之前
      pickerBeforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 日期只可设置当天之后
      pickerAfterToday: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      // 选择今天之后的日期(不能选择当天时间)
      pickerNoAfterToday: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      // 选择今天之前的日期(不能选择当天时间)
      pickerNoBeforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }

      // 两个时间输入框  开始时间不超过结束日期  (未完善)
      // 日期内容
      // seach: { before: '', after: '' },
      // pickerBeginDateBefore: {
      //   disabledDate: (time) => {
      //     const beginDateVal = this.seach.after
      //     if (beginDateVal) {
      //       return time.getTime() > beginDateVal
      //     }
      //   }
      // },
      // // 结束时间
      // pickerBeginDateAfter: {
      //   disabledDate: (time) => {
      //     const beginDateVal = this.seach.before
      //     if (beginDateVal) {
      //       return time.getTime() < beginDateVal
      //     }
      //   }
      // }
    }
  },
  methons: {
    // 选择开始时间，清空结束时间
    // changeTime(date) {
    //   // this.seach.before="";
    //   this.pickerBeginDateAfter = {
    //     disabledDate(time) { // 开始时间-结束时间
    //       return (time.getTime() < new Date(date).getTime())
    //     }
    //   }
    // }
  }
}
